import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import {
    downloadProcessedFilesReducer,
    getProcessedFilesReducer,
    mobileBulkValidationReducer,
    mobileSingleValidationReducer,
} from './mobile-validation/reducers';
import {
    downloadProcessedFileInitialState,
    mobileBulkValidationInitialState,
    mobileSingleValidationInitialState,
    processedFilesInitialState,
} from './mobile-validation/state';

const reducer = combineReducers({
    mobileSingleValidation: mobileSingleValidationReducer,
    mobileBulkValidation: mobileBulkValidationReducer,
    getProcessedFiles: getProcessedFilesReducer,
    downloadProcessedFiles: downloadProcessedFilesReducer,
});

const middleware = [thunk];

export const initialRootState = {
    mobileSingleValidation: mobileSingleValidationInitialState,
    mobileBulkValidation: mobileBulkValidationInitialState,
    getProcessedFiles: processedFilesInitialState,
    downloadProcessedFiles: downloadProcessedFileInitialState,
};

const store = createStore(reducer, initialRootState, composeWithDevTools(applyMiddleware(...middleware)));

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
